import {l} from "../../src/ts/debug/debug";

export class GeoPopup {

    private readonly SELECTOR_POPUP: string = '.geo-popup';
    private readonly SELECTOR_STAY_ON_SITE: string = '.geo-popup__stay';

    private readonly COOKIE_REDIRECT_NAME: string = 'user_stays_global';
    private readonly COOKIE_REDIRECT_VALUE: string = 'user_stays_global';

    private $geoPopup: JQuery;
    private $stayLink: JQuery;

    constructor() {
        this.$geoPopup = $(this.SELECTOR_POPUP);

        let cookie = this.readCookie(this.COOKIE_REDIRECT_NAME);

        if (cookie == this.COOKIE_REDIRECT_VALUE) {
            return;
        }

        if (this.$geoPopup.length) {
            this.$stayLink = this.$geoPopup.find(this.SELECTOR_STAY_ON_SITE);

            this.$stayLink.on('click', (e) => this.onStayOnSite(e));
            this.$geoPopup.fadeIn();
        }

    }

    private onStayOnSite(event: JQuery.ClickEvent) {
        this.$geoPopup.fadeOut();
        this.createCookie(this.COOKIE_REDIRECT_NAME, this.COOKIE_REDIRECT_VALUE, 1);

        return false;
    }

    private createCookie(name, value, days) {
        let expires;

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        } else {
            expires = '';
        }
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
    }

    private readCookie(name) {
        let nameEQ = encodeURIComponent(name) + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    private eraseCookie(name) {
        this.createCookie(name, '', -1);
    }
}